import axios from 'axios';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchRfidFilesErrorsList = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getRfidFilesErrorsList',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      id: payload.params.id,
    },
  });
  return axios.get(serviceUrl);
};

export default apiFetchRfidFilesErrorsList;
